export type CartItem = {
  id?: string;
  name?: string;
  itemNumber?: string;
  image?: string;
  itemMin?: number;
  itemMaxUs?: number;
  itemMaxIntl?: number;
  quantity: number;
  price: number;
  productLink: string;
};
/**
 * Key used to store cart in local storage
 * */
export const CART_KEY = 'nrc-cart';
/**
 * Read cart contents from local storage.
 * @returns An array of CartItem instances.
 * */
export const getCart = (): CartItem[] => JSON.parse(localStorage?.getItem(CART_KEY) ?? '[]');
/**
 * Counts the total number of items in a cart.
 * @param items The cart items to count.
 * @returns Total number of items in cart.
 * */
export const getTotalItemsInCart = (items: CartItem[]): number => {
  let returnquantity = 0;
  items.forEach((element) => {
    returnquantity += element.quantity;
  });
  return returnquantity;
};
